import { useState } from "react";

import { Button, DialogWrapper, LabelWrapper } from "@bridgesplit/ui";
import { AppDialog, useAppDialog } from "app/utils";
import { getLoopSlippage, getLoopSlippageTooltip } from "@bridgesplit/abf-react";
import { percentDecimalsToUi, percentUiToDecimals } from "@bridgesplit/utils";
import { COPY } from "app/constants";

import { HeaderWithClose, Slippage, SlippageValue } from "../../common";

export function WindSettingsDialog() {
    const { getData, close } = useAppDialog();

    const data = getData(AppDialog.WindSettings);

    const [slippageUi, setSlippageUi] = useState<SlippageValue | undefined>(
        percentDecimalsToUi(data?.form?.percentSlippageDecimals)
    );

    return (
        <DialogWrapper>
            <HeaderWithClose header={COPY.SLIPPAGE_SETTINGS} close={close} />
            <LabelWrapper
                label="Slippage"
                tooltip={data ? getLoopSlippageTooltip(data?.loopExpanded, "wind") : undefined}
            >
                <Slippage.Input
                    presets={getLoopSlippage(data?.loopExpanded).slippagePresetsUi}
                    value={slippageUi}
                    setValue={(val: SlippageValue | undefined) => setSlippageUi(val)}
                />
            </LabelWrapper>

            <Button
                disabled={!slippageUi}
                variant="contained"
                onClick={() => {
                    if (!slippageUi) return;
                    if (typeof slippageUi === "number") {
                        data?.setForm({
                            ...data?.form,
                            percentSlippageDecimals: percentUiToDecimals(slippageUi)
                        });
                    }
                    close();
                }}
            >
                {COPY.SAVE_SLIPPAGE}
            </Button>
        </DialogWrapper>
    );
}
